import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Link, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const KEY = "cookieConsent.v1";

// Інформаційний банер cookie (використовуються лише необхідні cookie).
export default function CookieConsent() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setOpen(true); } catch { /* ignore */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    setOpen(false);
  };

  if (!open) return null;
  return (
    <Box sx={{
      position: "fixed", left: 16, right: 16, bottom: 16, zIndex: 1400,
      maxWidth: 560, mx: "auto", p: 2, borderRadius: 3,
      bgcolor: "background.paper", boxShadow: 6, border: "1px solid", borderColor: "divider",
    }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ sm: "center" }}>
        <Typography variant="body2" sx={{ flexGrow: 1 }}>
          {t("cookieConsent.text")}{" "}
          <Link component={RouterLink} to="/cookies">{t("cookieConsent.more")}</Link>
        </Typography>
        <Button variant="contained" size="small" onClick={accept} sx={{ flexShrink: 0 }}>
          {t("cookieConsent.accept")}
        </Button>
      </Stack>
    </Box>
  );
}
